import React from 'react';
import {connect} from 'react-redux';
import {Row, Col} from 'react-bootstrap';
import {getPersonalTraining,getSession} from '../actions/ProAction';
import {DayInfoDetail, TrainingTitle} from '../components/DayInfoDetail';
import '../styles/css/Pro.SessionDetail.css';
import {pageView} from '../util/tracking';

class SessionDetail extends React.Component{
  constructor(props){
    super(props);
    this.state={
      session: null
    };
  }

  componentWillMount(){
    let {session_num} = this.props.match.params;

    if(!this.props.ptSessions){
      this.props.getPersonalTraining(this.props.courseId);
    }else{
      let sessionId = this.props.ptSessions[session_num-1].id;

      // in case user comes back to the existing dataset
      if(this.props.session.id !== sessionId){
        this.props.getSession(sessionId);
      }
    }
    pageView();
  }

  componentWillReceiveProps(nextProps){

    if(this.props.ptSessions !== nextProps.ptSessions){
      let {session_num} = this.props.match.params;
      let sessionId = nextProps.ptSessions[session_num-1].id;
      this.props.getSession(sessionId);
    }

    if(this.props.session !== nextProps.session){
      this.setState({session: nextProps.session})
    }

  }

  onPatternClick(evt){
    let session = {...this.state.session};
    let patternSet = session.data.filter(val=>val.type==='pattern');

    patternSet[0].sets[0].set = patternSet[0].sets[0].examples[evt];
    patternSet[0].sets[0].exp = patternSet[0].sets[0].patterns[evt];
    patternSet[0].sets[0].selected = `Pattern_${evt+1}`

    this.setState({session: session});
  }

  render(){
    let {session_num} = this.props.match.params;
    let {session}  = this.state;
    let handlers={onPatternClick:this.onPatternClick.bind(this)}
    return(
      <Row>
        <Col className="info_table dashboard" xs={12} md={10} mdOffset={1}>
          <TrainingTitle session_num={session_num} />
          {session?session.data.map((dailyContent, index)=>(
            <DayInfoDetail key={index} content={dailyContent} handlers={handlers} />)):null}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps=(state)=>{
  return{
    courseId: state.auth.courseId,
    ptSessions: state.pro.ptSessions,
    session: state.pro.session
  };
};

const mapDispatchToProps=(dispatch)=>{
  return{
    getPersonalTraining: (courseId)=>{
      dispatch(getPersonalTraining(courseId));
    },
    getSession: (session_num, materials)=>{
      dispatch(getSession(session_num, materials));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionDetail);



// WEBPACK FOOTER //
// ./src/containers/Pro.SessionDetail.js